// const addToCartBtn = document.querySelector(".add-to-cart");

// function to format money
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = format || this.money_format;
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

// function to init theme

const themeInit = () => {
  // Ensure running in browser
  if (typeof window === "undefined") return;

  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)");
  const body = document.body;
  const lightIcon = document.querySelector("#light-icon");
  const darkIcon = document.querySelector("#dark-icon");

  // Apply saved or system theme
  const savedTheme = localStorage.getItem("theme");
  const useDark = savedTheme ? savedTheme === "dark" : prefersDark.matches;
  body.classList.toggle("theme-dark", useDark);

  // Update icons
  lightIcon?.classList.toggle("hide_theme_icon", !useDark);
  darkIcon?.classList.toggle("hide_theme_icon", useDark);

  // Watch for system changes if no manual override
  prefersDark.addEventListener("change", (e) => {
    if (!localStorage.getItem("theme")) {
      body.classList.toggle("theme-dark", e.matches);
      lightIcon?.classList.toggle("hide_theme_icon", !e.matches);
      darkIcon?.classList.toggle("hide_theme_icon", e.matches);
    }
  });
};

// Run on load
// themeInit();

// Toggle manually
document
  .querySelector(".header_theme_button")
  ?.addEventListener("click", () => {
    const isDark = document.body.classList.toggle("theme-dark");
    localStorage.setItem("theme", isDark ? "dark" : "light");

    document
      .querySelector("#light-icon")
      ?.classList.toggle("hide_theme_icon", !isDark);
    document
      .querySelector("#dark-icon")
      ?.classList.toggle("hide_theme_icon", isDark);
  });

// const themeChange = ()=>{
//     window.matchMedia("(prefers-color-scheme: dark)").matches ? document.querySelector("body").classList.add("theme-dark") : document.querySelector("body").classList.remove("theme-dark");
// }

// console.log(`

//                                  █████
//                                 ███████
//                                █████████
//                                █████████
//                                █████████
//                                █████████
//                                  █████
//                          ███████  ███  ███████
//                         ███████████████████████
//                         ███████ ███████ ███████
//                         █████    █████    █████
//                        ████      █████      ████
//                     ██████        ███         █████
//                    ███████        ███        ███████
//                    ███████        ███         ██████
//                     ████          ███          ████
//                     ████     █████████████     ████
//                     ████    ███████████████    ████
//                     ████   █████████████████   ████
//                    ███████  ██████   ██████   ██████
//                    ███████   ████      ███   ███████
//                    ██████    ███       ███    ██████
//                              ██        ███
//                             ███         ███
//                             ███         ███
//                           ██████       ██████
//                           ███████     ███████
//                           ███████     ███████
//                            █████       █████
//                             ███         ███
//                             ███         ███
//                             ███         ███
//                            ████         ████
//                           ███████      ██████
//                           ███████     ███████
//                           ███████     ███████
//                            ██████     ██████
//                              ██         ██

//                        Built by www.vyuba.studio

//    `);

// star
// console.log(`
//                                     ██
//                                   ██████
//                                 ██████████
//                       ████████████████████████████████
//                         ████████████████████████████
//                           ████████████████████████
//                              ██████████████████
//                                   ████████
//                             ██████████████████
//                             ████████    ████████
//                           ██████          ██████
//                           █████              █████
//                         ███                     ███

//                         Built by www.vyuba.studio

//    `);
